import React, { useState } from "react";
import { Layout } from "antd";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Test from "./Pages/Test";
import NotFound from "./Pages/NotFound";
import PrivateOutlet from "./components/Shared/PrivateOutlet";
import ProtectedRoutes from "./components/Shared/ProtectedRoutes";
import SignForm from "./Pages/Login/SignForm";

import SideBar from "./components/Side/SideBar";

import Map from "./Pages/Map/Map";
import MapKMLViewer from "./components/map/GeoKMLMapDisplay";
import ClientsPage from "./Pages/Client/ClientsPage";
import ExploitationsPage from "./Pages/Exploitation/ExploitationsPage";
import CustomerCardPage from "./Pages/Client/CustomerCardPage";
import CreateCustomerPage from "./Pages/Client/CreateCustomerPage";
import EditCustomer from "./Pages/Client/EditCustomer";
import AllDomains from "./Pages/Domains/AllDomains";
import AnalysisPage from "./Pages/Analysis/AnalysisPage";
import InfoPage from "./Pages/Information/InfoPage";
import ExplCreationPage from "./Pages/Exploitation/ExplCreationPage";
import ProductsPage from "./Pages/Products/ProductsPage";
import LicensesPage from "./Pages/Licenses/LicensesPage";

import CreateSoilAnalysis from "./components/Analysis/Soil/CreateSoilAnalysis";
import EditSoilAnalysis from "./components/Analysis/Soil/EditSoilAnalysis";
import ViewSoilAnalysis from "./components/Analysis/Soil/ViewSoilAnalysis";

import CreateWaterAnalysis from "./components/Analysis/Water/CreateWaterAnalysis";
import EditWaterAnalysis from "./components/Analysis/Water/EditWaterAnalysis";
import ViewWaterAnalysis from "./components/Analysis/Water/ViewWaterAnalysis";

import CreateSoilSolution from "./components/Analysis/SoilSolution/CreateSoilSolution";
import EditSoilSolution from "./components/Analysis/SoilSolution/EditSoilSolution";
import ViewSSolution from "./components/Analysis/SoilSolution/ViewSSolution";

import CreateLeafAnalysis from "./components/Analysis/Leaves/CreateLeafAnalysis";
import EditLeafAnalysis from "./components/Analysis/Leaves/EditLeafAnalysis";
import ViewLeafAnalysis from "./components/Analysis/Leaves/ViewLeafAnalysis";
import MapDomain from "./components/map/MapDomain";
import MapExploitation from "./components/map/MapExploitation";
import ClientPage from "./Pages/Client/ClientPage";
import About from "./Pages/footer/About";
import Contact from "./Pages/footer/Contact";

const { Content } = Layout;
const SIDEBAR_WIDTH = 250;
const SIDEBAR_COLLAPSED_WIDTH = 80;

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<SignForm />} />
          <Route path="/login" element={<SignForm />} />
          <Route path="/test" element={<Test />} />
          
          {/* Public routes - accessible without authentication */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          
          <Route
            element={
              <>
                <SideBar hasSider collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
                <Layout className="site-layout"
                style={{
                  marginLeft: sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH,
                  transition: 'margin-left 0.2s'
                }}>
                  <Content style={{ 
                    overflow: 'auto',
                    height: '100vh',
                    backgroundColor: '#ffffff',
                  }}>
                    <PrivateOutlet />
                  </Content>
                </Layout>
              </>
            }
          >
            {/* protected routes */}
            {/* Admin Routes */}
            <Route path="/admin/*" element={
              <ProtectedRoutes allowedRoles={['superadmin']}>
                <Routes>

                  {/* client routes */}
                  <Route path="/client/all" element={<ClientsPage />} />
                  <Route path="/client/:clientId/show-info" element={<CustomerCardPage />} />
                  <Route path="/client/add" element={<CreateCustomerPage />} />
                  <Route path="/client/:clientId/edit" element={<EditCustomer />} />

                  {/* exploitation routes */}
                  <Route path="/exploitation/all" element={<ExploitationsPage />} />
                  <Route path="/exploitation/create" element={<ExplCreationPage />} />

                  {/* produit routes */}
                  <Route path="/products/all" element={<ProductsPage />} />

                  {/* license routes */}
                  <Route path="/licenses" element={<LicensesPage />} />

                  {/* domain routes */}
                  <Route path="/domains/all" element={<AllDomains />} />

                  {/* analysis routes */}
                  <Route path="/exploitation/:exploitationId/analysis/:analysisType" element={<AnalysisPage />} />

                  {/* soil analysis routes */}
                  <Route path="/exploitation/:exploitationId/create-soil-analysis" element={<CreateSoilAnalysis />} />
                  <Route path="/exploitation/:exploitationId/edit-soil-analysis/:analysisId" element={<EditSoilAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-soil-analysis/:analysisId" element={<ViewSoilAnalysis />} />

                  {/* water analysis routes */}
                  <Route path="/exploitation/:exploitationId/create-water-analysis" element={<CreateWaterAnalysis />} />
                  <Route path="/exploitation/:exploitationId/edit-water-analysis/:analysisId" element={<EditWaterAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-water-analysis/:analysisId" element={<ViewWaterAnalysis />} />

                  {/* soil solution routes */}
                  <Route path="/exploitation/:exploitationId/create-soil-solution" element={<CreateSoilSolution />} />
                  <Route path="/exploitation/:exploitationId/edit-soil-solution/:analysisId" element={<EditSoilSolution />} />
                  <Route path="/exploitation/:exploitationId/view-soil-solution/:analysisId" element={<ViewSSolution />} />

                  {/* leaf analysis routes */}
                  <Route path="/exploitation/:exploitationId/create-leaf-analysis" element={<CreateLeafAnalysis />} />
                  <Route path="/exploitation/:exploitationId/edit-leaf-analysis/:analysisId" element={<EditLeafAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-leaf-analysis/:analysisId" element={<ViewLeafAnalysis />} />

                  {/* info routes */}
                  <Route path="/exploitation/:exploitationId/info/:infoType" element={<InfoPage />} />

                  {/* map routes */}
                  <Route path="/" element={<Map />} />
                  <Route path="/map" element={<Map />}>
                    <Route path="" element={<MapKMLViewer />}>
                      <Route path="domain/:domainId" element={<MapDomain />} />
                      <Route path="exploitation/:explotId" element={<MapExploitation />} />
                    </Route>
                  </Route>
                </Routes>
              </ProtectedRoutes>
            } />

            {/* User Routes */}
            <Route path="/client/*" element={
              <ProtectedRoutes allowedRoles={['client', 'admin', 'superadmin']}>
                <Routes>
                  <Route path="/exploitation/all" element={<ExploitationsPage />} />
                  <Route path="/profile" element={<ClientPage />} />
                  <Route path="/associated-domains" element={<AllDomains />} />


                  {/* analysis routes read only */}
                  <Route path="/exploitation/:exploitationId/analysis/:analysisType" element={<AnalysisPage />} />

                  {/* soil analysis routes */}
                  <Route path="/exploitation/:exploitationId/view-soil-analysis/:analysisId" element={<ViewSoilAnalysis />} />

                  {/* water analysis routes */}
                  <Route path="/exploitation/:exploitationId/view-water-analysis/:analysisId" element={<ViewWaterAnalysis />} />

                  {/* soil solution routes */}
                  <Route path="/exploitation/:exploitationId/view-soil-solution/:analysisId" element={<ViewSSolution />} />

                  {/* leaf analysis routes */}
                  <Route path="/exploitation/:exploitationId/view-leaf-analysis/:analysisId" element={<ViewLeafAnalysis />} />

                  {/* info routes */}
                  <Route path="/exploitation/:exploitationId/info/:infoType" element={<InfoPage />} />

                  {/* map routes */}
                  <Route path="/" element={<Map />} />
                  <Route path="/map" element={<Map />}>
                    <Route path="" element={<MapKMLViewer />}>
                      <Route path="domain/:domainId" element={<MapDomain />} />
                      <Route path="exploitation/:explotId" element={<MapExploitation />} />
                    </Route>
                  </Route>

                </Routes>
              </ProtectedRoutes>
            } />

            {/* New Exploitation Manager Routes*/}
            <Route path="/exploitation-manager/*" element={
              <ProtectedRoutes allowedRoles={['exploitation_manager', 'admin', 'superadmin', 'domain_manager']}>
                <Routes>
                  <Route path="/profile" element={<ClientPage />} />
                  <Route path="/exploitations" element={<ExploitationsPage />} />
                  <Route path="/exploitation/:exploitationId/analysis/:analysisType" element={<AnalysisPage />} />
                  <Route path="/exploitation/:exploitationId/view-soil-analysis/:analysisId" element={<ViewSoilAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-water-analysis/:analysisId" element={<ViewWaterAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-soil-solution/:analysisId" element={<ViewSSolution />} />
                  <Route path="/exploitation/:exploitationId/view-leaf-analysis/:analysisId" element={<ViewLeafAnalysis />} />
                  <Route path="/exploitation/:exploitationId/info/:infoType" element={<InfoPage />} />
                  <Route path="/map" element={<Map />}>
                    <Route path="" element={<MapKMLViewer />}>
                      <Route path="exploitation/:explotId" element={<MapExploitation />} />
                    </Route>
                  </Route>
                </Routes>
              </ProtectedRoutes>
            } />

            {/* New Domain Manager Routes */}
            <Route path="/domain-manager/*" element={
              <ProtectedRoutes allowedRoles={['domain_manager', 'admin', 'superadmin']}>
                <Routes>
                  <Route path="/profile" element={<ClientPage />} />
                  <Route path="/exploitations" element={<ExploitationsPage />} />
                  <Route path="/associated-domains" element={<AllDomains />} />

                  <Route path="/exploitation/:exploitationId/analysis/:analysisType" element={<AnalysisPage />} />
                  <Route path="/exploitation/:exploitationId/view-soil-analysis/:analysisId" element={<ViewSoilAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-water-analysis/:analysisId" element={<ViewWaterAnalysis />} />
                  <Route path="/exploitation/:exploitationId/view-soil-solution/:analysisId" element={<ViewSSolution />} />
                  <Route path="/exploitation/:exploitationId/view-leaf-analysis/:analysisId" element={<ViewLeafAnalysis />} />
                  <Route path="/exploitation/:exploitationId/info/:infoType" element={<InfoPage />} />
                  <Route path="/map" element={<Map />}>
                    <Route path="" element={<MapKMLViewer />}>
                      <Route path="domain/:domainId" element={<MapDomain />} />
                      <Route path="exploitation/:explotId" element={<MapExploitation />} />
                    </Route>
                  </Route>
                </Routes>
              </ProtectedRoutes>
            } />

          </Route>
          <Route path="*" element={<NotFound />} />

        </Routes>
      </Layout>
    </Router>
  );
}

export default App;